import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createAccount } from '../api/auth';
import { useAuth } from '../context/AuthProvider';

// Page d'inscription
function SignUp() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { loginUser } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const data = await createAccount({ name, email, password });
            loginUser(data.user, data.token);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || 'Erreur lors de l\'inscription');
        }
    };

    return (
        <section className="max-w-md mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10 text-center">Create Account</h1>
            {error && <p className="bg-red-900 text-red-300 p-3 rounded-lg mb-6 text-center">{error}</p>}
            <form onSubmit={handleSubmit} className="bg-gray-900 border border-gray-800 rounded-xl p-8 space-y-4">
                <div>
                    <label className="block text-sm text-gray-400 mb-2">Name</label>
                    <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Your name" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none" />
                </div>
                <div>
                    <label className="block text-sm text-gray-400 mb-2">Email</label>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none" />
                </div>
                <div>
                    <label className="block text-sm text-gray-400 mb-2">Password</label>
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none" />
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold">Create Account</button>
            </form>
            <p className="text-center text-gray-400 mt-6">Déjà un compte ? <Link to="/login" className="text-blue-400 hover:text-blue-300">Se connecter</Link></p>
        </section>
    );
}

export default SignUp;